export const MAX_LOTS_PER_LABEL = 5

export interface PalletLabelLot {
  lotNumber?: string | null
  batchNumber?: string | null
  quantity?: number | string | null
}

export interface PalletLabelParams {
  productName: string
  referenceId: string
  stockNumber: string
  palletQuantity: string
  packageQuantity: string
  packageCount: number
  lots: PalletLabelLot[]
  uomName: string
}

export const generatePalletLabelZpl = (params: PalletLabelParams): string => {
  const { productName, referenceId, stockNumber, palletQuantity, packageQuantity, packageCount, lots, uomName } = params

  const qrData = JSON.stringify({
    version: 1,
    eventType: "put-away",
    refId: referenceId,
  })

  const lotYOffset = 35
  const lotYStart = 985
  const lotsZpl = lots
    .slice(0, MAX_LOTS_PER_LABEL)
    .map((lot, i) => {
      const batchNumber = lot.batchNumber ? ` - ${lot.batchNumber}` : ""
      return `^FO400,${lotYStart + lotYOffset * i}^A0N,30,30^FD${lot.lotNumber + batchNumber} (${lot.quantity} ${uomName})^FS`
    })
    .join("")

  return `^XA
    ^PW800^LL1200^LS0^LT0
    ^CI28~TA000~JSB^MNW^MTD^PMN^JMA^PR4,4~SD20^PA0,0,0,0
    ^FO60,50^A0N,44,50^FB700,2,0,C,0^FD${productName}^FS
    ^FO200,120^BQN,2,11^FDMA,${qrData}^FS
    ^FO50,516^GB700,180,180^FS
    ^FO50,535^A0N,180,200^FB750,1,0,C,0^FR^FD${referenceId}^FS
    ^FO0,725^A0N,46,56^FB800,1,0,C,0^FDStock #: ${stockNumber}^FS
    ^FO20,795^GB760,3,3^FS
    ^FO70,835^A0N,35,35^FDFull Pallet UoM:^FS
    ^FO70,885^A0N,35,35^FDStd Package UoM:^FS
    ^FO70,935^A0N,35,35^FDFull Package Count:^FS
    ^FO70,985^A0N,35,35^FDReceived Lot(s) #:^FS
    ^FO400,835^A0N,35,35^FD${palletQuantity} ${uomName}^FS
    ^FO400,885^A0N,35,35^FD${packageQuantity} ${uomName}^FS
    ^FO400,935^A0N,35,35^FD${packageCount}^FS
    ${lotsZpl}
    ^XZ`
}
